var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box, InlineForm } from '#design-system';
import { ComboboxField, NumberInputField } from '#fields';
import { FormRoot, useFormRoot } from '#form-builder';
import styles from './NumberWithUnitForm.module.css';
const NumberWithUnitFields = ({ cancelAriaLabel, clientErrorMessage, 'data-testid': dataTestId, initialNumberValue, initialUnitValue, inlineFormValue, inputId, isSuccess, label, labelDefault, labelTooltip, numberInputName, numberInputRules, numberInputValidator, onSave, resetToDefault, saveAriaLabel, unitAriaLabel, unitInputName, unitInputTestId, unitOptions, }) => {
    _react_refresh_temp_3();
    const { errors, formData } = useFormRoot();
    const numberInputError = errors[numberInputName];
    const numberInputValue = formData[numberInputName];
    const unitValue = formData[unitInputName];
    const numberDependencyExtractor = useCallback((formData) => formData[unitInputName], [unitInputName]);
    const handleSave = useCallback(() => {
        onSave(Number(numberInputValue), unitValue);
    }, [numberInputValue, unitValue, onSave]);
    const formElement = useCallback((labelProps) => (_jsxs(Box, { align: "start", gap: "s", isFullWidth: true, orientation: "horizontal", children: [_jsx(NumberInputField, { ...labelProps, autoFocus: true, className: styles.NumberInput, clientErrorMessage: clientErrorMessage, "data-testid": dataTestId, dependencyExtractor: numberDependencyExtractor, id: dataTestId, initialValue: initialNumberValue, name: numberInputName, rules: numberInputRules, validator: numberInputValidator }), _jsx(ComboboxField, { "aria-label": unitAriaLabel, className: styles.UnitInput, "data-testid": unitInputTestId, id: unitInputTestId, initialValue: initialUnitValue, isMultiselect: false, isSearchable: false, name: unitInputName, options: unitOptions })] })), [
        numberDependencyExtractor,
        dataTestId,
        clientErrorMessage,
        initialNumberValue,
        numberInputName,
        numberInputRules,
        numberInputValidator,
        unitAriaLabel,
        unitInputTestId,
        initialUnitValue,
        unitInputName,
        unitOptions,
    ]);
    return (_jsx(Box, { align: "start", gap: "s", isFullWidth: true, orientation: "horizontal", children: _jsx(InlineForm, { cancelAriaLabel: cancelAriaLabel, "data-testid": dataTestId, formElement: formElement, inputId: inputId, isSaveAllowed: !numberInputError, isSuccess: isSuccess, label: label, labelDefault: labelDefault, labelTooltip: labelTooltip, onSave: handleSave, resetToDefault: resetToDefault, saveAriaLabel: saveAriaLabel, tooltipPosition: "right", value: inlineFormValue }) }));
};
_react_refresh_temp_1 = NumberWithUnitFields;
$RefreshReg$(_react_refresh_temp_1, "NumberWithUnitFields");
_react_refresh_temp_3(NumberWithUnitFields, "Uh2/8zIDxDNGAE6+Dhzn3P6davg=", false, () => [useFormRoot]);
export const NumberWithUnitForm = ({ onChange, ...rest }) => {
    return (_jsx(FormRoot, { "data-testid": `${rest['data-testid']}-inline-form`, ...(onChange ? { onChange } : {}), children: _jsx(NumberWithUnitFields, { ...rest }) }));
};
_react_refresh_temp_2 = NumberWithUnitForm;
$RefreshReg$(_react_refresh_temp_2, "NumberWithUnitForm");
